var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk261274430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173.8 30",
    style: {
      enableBackground: "new 0 0 173.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 7.1,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 15.2405 76.2376)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 7.2,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 61.7995 149.4408)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,30h-30V0.1h30V30z M144.8,28.8h27.7V1.2h-27.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,26H147V3.8h22.7V26z M148.2,24.8h20.4V4.9h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.6,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.4355 15.9862)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8138 9.6829)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0.1h30V30z M1.2,28.8h27.7V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6,25.9H3.9V3.8h22.7V25.9z M5.1,24.8h20.4V4.9H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6,
    y: -6.6,
    transform: "matrix(0.4703 -0.8825 0.8825 0.4703 15.5923 41.2371)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.0126 23.9341)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7,30h-30V0.1h30V30z M29.8,28.8h27.7V1.2H29.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2,25.9H32.5V3.8h22.7V25.9z M33.7,24.8h20.4V4.9H33.7V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: -6.6,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 30.8885 66.7318)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.1746 38.3229)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,30h-30V0.1h30V30z M58.7,28.8h27.7V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1,25.9H61.5V3.8h22.7V25.9z M62.6,24.8H83V4.9H62.6V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4,
    y: 7.1,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.4782 49.1815)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.8,
    y: 7.2,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 32.9146 99.5629)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,30h-30V0.1h30V30z M87.3,28.8H115V1.2H87.3V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2,26H89.5V3.8h22.7V26z M90.7,24.8h20.4V4.9H90.7V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.2,
    y: 7.1,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.8594 62.7096)",
    width: 28.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 7.2,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 47.357 124.5019)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,30h-30V0.1h30V30z M116,28.8h27.7V1.2H116V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,26h-22.7V3.8H141V26z M119.4,24.8h20.4V4.9h-20.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 27.4,
    transform: "matrix(0.4045 -0.9145 0.9145 0.4045 9.5072 70.5641)",
    width: 2.3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,24.1l-1.1-0.5l1.8-4.1l1.1,0.5L61.3,24.1z M64.4,16.9l-1.1-0.5l1.8-4.1l1.1,0.5L64.4,16.9z M67.6,9.8l-1.1-0.5 l1.8-4.1l1.1,0.5L67.6,9.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 0.8,
    transform: "matrix(0.4045 -0.9145 0.9145 0.4045 40.8572 65.4132)",
    width: 2.3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1,
    y: 26.9,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -2.6054 46.1301)",
    width: 1.1,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,24.2l-2.3-4.1l1-0.6l2.3,4.1L83.9,24.2z M79.8,17l-2.3-4.1l1-0.6l2.3,4.1L79.8,17z M75.8,9.8l-2.3-4.1l1-0.6l2.3,4.1 L75.8,9.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 0.1,
    transform: "matrix(0.8725 -0.4886 0.4886 0.8725 8.5105 35.1903)",
    width: 1.1,
    height: 2.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk261274430);
export default __webpack_public_path__ + "static/media/AK2_6_127443_0.7153448abcdd58f06c96749b74c8ffaa.svg";
export { ForwardRef as ReactComponent };